// ============================================================================
// OddsRail — glues a list of OddsMarkets to a widget's bottom edge
// ============================================================================
// Sits inside the widget card. Top divider separates data from odds; thin
// dividers between markets. Renders nothing if the list is empty.
// ============================================================================

import type { ReactElement } from 'react';
import OddsMarket from './OddsMarket.js';
import type { DisplayMarket } from '../../types/odds.js';
import styles from './OddsRail.module.css';

export interface OddsRailProps {
  markets: DisplayMarket[];
  onSelect?: (outcomeId: number) => void;
  /** Locale-aware decimal separator for odds display ('.' or ','). */
  decimalSeparator?: '.' | ',';
}

export function OddsRail({
  markets,
  onSelect,
  decimalSeparator,
}: OddsRailProps): ReactElement | null {
  if (markets.length === 0) return null;

  return (
    <div className={styles.rail}>
      {markets.map((m) => (
        <OddsMarket
          key={m.key}
          market={m}
          {...(onSelect !== undefined ? { onSelect } : {})}
          {...(decimalSeparator !== undefined ? { decimalSeparator } : {})}
        />
      ))}
    </div>
  );
}

export default OddsRail;
